import { render, staticRenderFns } from "./square-list.vue?vue&type=template&id=52448df2&scoped=true&"
import script from "./square-list.vue?vue&type=script&lang=js&"
export * from "./square-list.vue?vue&type=script&lang=js&"
import style0 from "./square-list.vue?vue&type=style&index=0&id=52448df2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52448df2",
  null
  
)

export default component.exports